import { render, staticRenderFns } from "./BaseTableUploadProgress.vue?vue&type=template&id=af2be5f6&scoped=true&"
import script from "./BaseTableUploadProgress.vue?vue&type=script&lang=js&"
export * from "./BaseTableUploadProgress.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableUploadProgress.vue?vue&type=style&index=0&id=af2be5f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2be5f6",
  null
  
)

export default component.exports